export class Analytics {
    charts: Record<string, any>;
    /**
     * How many campaigns the campaign status filter admitted, or null under All and before
     * the first response. Zero is what the dashboard's empty state keys off (MPN-1964).
     */
    statusMatches: number | null;

    constructor(data?: Partial<Analytics>) {
        this.charts = data?.charts ?? {};
        this.statusMatches = data?.statusMatches ?? null;
    }
}
